<template>
  <div id="contact" class="container-fluid">
    <div class="row skg-wording text-center">
      <div class="col-12 padding-div">
        <h1>CONTACT US</h1>
        <h5 class="pt-2">
          We'd love to dicuss your upcoming project with you!
        </h5>
      </div>
      <div class="col-12 pt-2">
        Call:
        <a class="contact-email" href="tel:208-740-7130">208-740-7130</a>
      </div>
      <div class="col-12 pt-2">
        Text:
        <a class="contact-email" href="sms:208-740-7130">208-740-7130</a>
      </div>
      <div class="col-12 pt-2">
        Email:
        <a
          class="contact-email"
          href="mailto:skg.construction@yahoo.com"
          target="_top"
          >skg.construction@yahoo.com</a
        >
      </div>
      <div class="col-12 pt-4">
        <a
          class="fab fa-facebook-square fa-3x contact-facebook"
          href="https://www.facebook.com/SKGConstruction"
          target="_blank"
        ></a>
      </div>
      <div class="col-12 pt-4">1336 Owyhee Ave</div>
      <div class="col-12 pt-4">Nyssa, OR 97913</div>
      <div class="col-12 pt-4">Oregon License # 171675</div>
    </div>
    <div class="div-hr-padding">
      <hr class="div-hr" />
    </div>
    <div class="col-12 pt-3 pb-1 text-center foot">
      Copyright {{ currentYear }} SKG Construction LLC
    </div>
    <div class="col-12 pb-4 text-center foot">
      Website by
      <a
        class="contact-email"
        href="mailto:jake@upfrontmanagement.com"
        target="_top"
        >Upfront</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style>
.contact-facebook {
  color: red;
}
.contact-email {
  color: rgb(22, 21, 21);
}
.foot {
  font-size: 1.5vh;
  color: gray;
}
</style>